import React, { useRef, useState } from "react";
import { useEffect } from "react";
import languageStorage from "../lang/findLanguage";
import { GrFormClose } from "react-icons/gr";
import { BsQuestion } from "react-icons/bs";

import emailjs from "emailjs-com";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function EmailPopup({ language }) {
  const [langPref, setLangPref] = useState(languageStorage());
  const [langEn, setLangEn] = useState(language[1].sections[14].keys);
  const [langTr, setLangTr] = useState(language[0].sections[14].keys);
  const [isVisible, setIsVisible] = useState(true);
  const [isSending, setIsSending] = useState(false);
  const [email, setEmail] = useState(null);
  const formRef = useRef(null);
  const handleCloseClick = () => {
    setIsVisible((prev) => !prev);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      toast.warning(langPref === "tr" ? langTr[5].k0006 : langEn[5].k0006);
      return;
    }

    setIsSending(true);
    emailjs
      .sendForm(
        "service_7svsb9o",
        "template_z10wze6",
        e.target,
        "5Yw0-u8sxfcnzRpaY"
      )
      .then(
        (result) => {
          setIsSending(false);
          setIsVisible(false);
          formRef.current.reset();
          toast.success(langPref === "tr" ? langTr[3].k0004 : langEn[3].k0004);
        },
        (error) => {
          setIsSending(false);
          toast.success(langPref === "tr" ? langTr[4].k0005 : langEn[4].k0005);
        }
      );
  };

  return (
    <>
      <div
        className={`email-popup ${
          isVisible ? "popup-visible" : "popup-hidden"
        }`}
      >
        <div className='subscribe'>
          <div className='close-btn' onClick={handleCloseClick}>
            <GrFormClose size={25} />
          </div>
          <span className='subscribe__title'>
            {langPref === "tr" ? langTr[0].k0001 : langEn[0].k0001}
          </span>

          <form ref={formRef} className='form' onSubmit={handleFormSubmit}>
            <input
              type='email'
              className='form__email'
              placeholder={
                langPref === "tr" ? langTr[1].k0002 : langEn[1].k0002
              }
              name='email'
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type='submit' className='form__button' disabled={isSending}>
              {langPref === "tr" ? langTr[2].k0003 : langEn[2].k0003}
            </button>
          </form>
        </div>
      </div>
      <div
        onClick={handleCloseClick}
        className={`float-email-button ${
          isVisible ? "button-hidden" : "button-visible"
        }`}
      >
        <BsQuestion size={45} color={"#df500eff"} />
      </div>
      <ToastContainer
        position={toast.POSITION.TOP_LEFT}
        hideProgressBar={false}
        autoClose={5000}
      />
    </>
  );
}

export default EmailPopup;
